<template>
  <div class="deskblock">
    <div class="title">
      <h3>消息通知</h3>
      <a @click="getAlotData">更多消息</a>
    </div>

    <Row style="margin-top: 20px">
      <Col class="zixun" span="24" v-for="(item, index) in items" :key="index"
        ><div class="alarmtitle">
          <h4>{{ item.title }}</h4>
          <span>{{ utils.time(item.time, "mmddhhmm") }}</span>
        </div>

        <Tooltip max-width="300" :content="item.content" placement="top-start">
          <p class="nocontent">{{ item.content }}</p>
        </Tooltip>
      </Col>
    </Row>
    <Drawer v-model="openForm" width='400'>
      <Row style="margin-top: 20px">
        <Col class="zixun" span="24" v-for="(item, index) in alots" :key="index"
          ><div class="alarmtitle">
            <h4>{{ item.title }}</h4>
            <span>{{ utils.time(item.time, "mmddhhmm") }}</span>
          </div>

          <Tooltip
            max-width="300"
            :content="item.content"
            placement="top-start"
          >
            <p class="nocontent">{{ item.content }}</p>
          </Tooltip>
        </Col>
      </Row>
    </Drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [],
      searchItem: {
        endTime: 0,
        startTime: 0,
        //isRead: false,
        model: 0, //模式（0-全部，1-发送，2-接收）
        data: 0, //数据范围（0-所有，1-所属部门及一下，2-所属部）
        pageNumber: 1,
        pageSize: 4,
        type: 2, //类型（0-其他，1-系统，2-用户，3-流程）
      },
      openForm: false,
      alots: [],
    };
  },
  methods: {
    ///cloud-common-server-msg/remind/list
    getData() {
      ///cloud-tms-server-omc/orders/indexPendingCount
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-common-server-msg/notice/list",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data.dataList;
        //console.log(this.utils.time(this.searchItem.startTime));
        //console.log(this.utils.time(-1000));
       // console.log('hongyuantongzhi',res);
        this.items.length = 0;
        for (let i = 0; i < data.length; i++) {
          var obj = {
            content: data[i].content,
            title: data[i].title,
            time: data[i].noticeTime,
          };
          this.items.push(obj);
        }
      });
    },
    getAlotData() {
      var obj = {
        startTime: this.searchItem.startTime,
        endTime: this.searchItem.endTime,
        model: 0, //模式（0-全部，1-发送，2-接收）
        data: 0, //数据范围（0-所有，1-所属部门及一下，2-所属部）
        pageNumber: 1,
        pageSize: 30,
        type: 2, //类型（0-其他，1-系统，2-用户，3-流程）
      };
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-common-server-msg/notice/list",
        data: obj,
      }).then((res) => {
        console.log('hongpeizhi',res);
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.alots.length = 0;
        for (let i = 0; i < data.length; i++) {
          var obj = {
            content: data[i].content,
            title: data[i].title,
            time: data[i].noticeTime,
          };
          this.alots.push(obj);
        }
        this.openForm=true;
      });
    },
    defaultTime() {
      var date = new Date();
      this.yy = date.getFullYear();
      this.mm = date.getMonth();
      this.dd = date.getDate();

      this.searchItem.startTime = new Date(this.yy, 0, 1).getTime();
      this.searchItem.endTime = new Date(this.yy + 1, 0, 1).getTime() - 1000;
      this.getData();
    },
  },
  mounted() {
    this.defaultTime();
  },
};
</script>
<style lang="">
.wuliuicon i {
  font-size: 36px;
}
.zixun {
  margin-top: 15px;
}
.zixun .alarmtitle {
  display: flex;
}
.zixun h4 {
  font-size: 14px;
  font-weight: bold;
}
.zixun span {
  margin-left: auto;
  color: #999;
}
.zixun .nocontent {
  height: 20px;
  overflow: hidden;
}
.zixun .nocontent:hover {
  color: red;
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/block7.vue